import { createAction, handleActions } from "redux-actions";

const actionScope = "PATIENT_SESSION_";

export const patientSessionRequestFailed = createAction(actionScope + "REQUEST_FAIL");

export const loadPatientODMRequest = createAction(actionScope + "LOAD_PATIENT_ODM_REQUEST");
export const loadPatientODMSuccess = createAction(actionScope + "LOAD_PATIENT_ODM_SUCCESS");

export const setPatientODMRequest = createAction(actionScope + "SET_PATIENT_ODM_REQUEST");
export const setPatientODMSuccess = createAction(actionScope + "SET_PATIENT_ODM_SUCCESS");

export const updatePatientRequest = createAction(actionScope + "UPDATE_PATIENT_REQUEST");
export const updatePatientSuccess = createAction(actionScope + "UPDATE_PATIENT_SUCCESS");

export const deletePatientRequest = createAction(actionScope + "DELETE_PATIENT_REQUEST");
export const deletePatientSuccess = createAction(actionScope + "DELETE_PATIENT_SUCCESS");

export const loadPatientAssessmentsRequest = createAction(
  actionScope + "LOAD_PATIENT_ASSESSMENTS_REQUEST"
);
export const loadPatientAssessmentsSuccess = createAction(
  actionScope + "LOAD_PATIENT_ASSESSMENTS_SUCCESS"
);

export const loadAssessmentODMRequest = createAction(actionScope + "LOAD_ASSESSMENT_ODM_REQUEST");
export const loadAssessmentODMSuccess = createAction(actionScope + "LOAD_ASSESSMENT_ODM_SUCCESS");

export const updateAssessmentRequest = createAction(actionScope + "UPDATE_ASSESSMENT_REQUEST");
export const updateAssessmentSuccess = createAction(actionScope + "UPDATE_ASSESSMENT_SUCCESS");

//#region REFACTOR and DELETE

//these method below are for loading addtional data and could all be -----------------------

export const loadPatientChartRequest = createAction(actionScope + "LOAD_PATIENT_CHART_REQUEST");
export const loadPatientChartSuccess = createAction(actionScope + "LOAD_PATIENT_CHART_SUCCESS");

export const loadPatientImageRequest = createAction(actionScope + "LOAD_PATIENT_IMAGE_REQUEST");
export const loadPatientImageSuccess = createAction(actionScope + "LOAD_PATIENT_IMAGE_SUCCESS");

export const loadPatientComplianceRequest = createAction(
  actionScope + "LOAD_PATIENT_COMPLIANCE_REQUEST"
);
export const loadPatientComplianceSuccess = createAction(
  actionScope + "LOAD_PATIENT_COMPLIANCE_SUCCESS"
);

export const loadPatientNotesRequest = createAction(actionScope + "LOAD_PATIENT_NOTES_REQUEST");
export const loadPatientNotesSuccess = createAction(actionScope + "LOAD_PATIENT_NOTES_SUCCESS");
export const updatePatientNoteRequest = createAction(actionScope + "UPDATE_PATIENT_NOTE_REQUEST");
export const updatePatientNoteSuccess = createAction(actionScope + "UPDATE_PATIENT_NOTE_SUCCESS");
export const deletePatientNoteRequest = createAction(actionScope + "DELETE_PATIENT_NOTE_REQUEST");
export const deletePatientNoteSuccess = createAction(actionScope + "DELETE_PATIENT_NOTE_SUCCESS");

//#region Motivations
export const loadMotivationODMRequest = createAction(actionScope + "LOAD_MOTIVATION_ODM_REQUEST");
export const loadMotivationODMSuccess = createAction(actionScope + "LOAD_MOTIVATION_ODM_SUCCESS");

export const loadPatientMotivationsRequest = createAction(
  actionScope + "LOAD_PATIENT_MOTIVATION_REQUEST"
);
export const loadPatientMotivationsSuccess = createAction(
  actionScope + "LOAD_PATIENT_MOTIVATIONS_SUCCESS"
);
export const updateMotivationRequest = createAction(
  actionScope + "UPDATE_PATIENT_MOTIVATION_REQUEST"
);
export const updateMotivationSuccess = createAction(
  actionScope + "UPDATE_PATIENT_MOTIVATION_SUCCESS"
);
export const deleteMotivationRequest = createAction(
  actionScope + "DELETE_PATIENT_MOTIVATION_REQUEST"
);
export const deleteMotivationSuccess = createAction(
  actionScope + "DELETE_PATIENT_MOTIVATION_SUCCESS"
);

//#endregion

export const loadPatientQuestionsRequest = createAction(
  actionScope + "LOAD_PATIENT_QUESTIONS_REQUEST"
);
export const loadPatientQuestionsSuccess = createAction(
  actionScope + "LOAD_PATIENT_QUESTIONS_SUCCESS"
);
export const updatePatientQuestionRequest = createAction(
  actionScope + "UPDATE_PATIENT_QUESTION_REQUEST"
);
export const updatePatientQuestionSuccess = createAction(
  actionScope + "UPDATE_PATIENT_QUESTION_SUCCESS"
);
export const deletePatientQuestionRequest = createAction(
  actionScope + "DELETE_PATIENT_QUESTION_REQUEST"
);
export const deletePatientQuestionSuccess = createAction(
  actionScope + "DELETE_PATIENT_QUESTION_SUCCESS"
);

//implementation is demo
export const updatePatientMedicationsRequest = createAction(
  actionScope + "UPDATE_PATIENT_MEDICATION_REQUEST"
);
export const updatePatientMedicationsSuccess = createAction(
  actionScope + "UPDATE_PATIENT_MEDICATION_SUCCESS"
);

//implementation is demo
export const updatePatientConditionsRequest = createAction(
  actionScope + "UPDATE_PATIENT_CONDTION_REQUEST"
);
export const updatePatientConditionsSuccess = createAction(
  actionScope + "UPDATE_PATIENT_CONDTION_SUCCESS"
);

//implementation is demo
export const updatePatientSymptomsRequest = createAction(
  actionScope + "UPDATE_PATIENT_SYMPTOMS_REQUEST"
);
export const updatePatientSymptomsSuccess = createAction(
  actionScope + "UPDATE_PATIENT_SYMPTOMS_SUCCESS"
);

export const updatePatientGoalsRequest = createAction(actionScope + "UPDATE_PATIENT_GOALS_REQUEST");
export const updatePatientGoalsSuccess = createAction(actionScope + "UPDATE_PATIENT_GOALS_SUCCESS");

export const loadPatientJournalRequest = createAction(actionScope + "LOAD_PATIENT_JOURNAL_REQUEST");
export const loadPatientJournalSuccess = createAction(actionScope + "LOAD_PATIENT_JOURNAL_SUCCESS");
export const updatePatientJournalEntryRequest = createAction(
  actionScope + "UPDATE_PATIENT_JOURNAL_REQUEST"
);
export const updatePatientJournalEntrySuccess = createAction(
  actionScope + "UPDATE_PATIENT_JOURNAL_SUCCESS"
);
export const deletePatientJournalEntryRequest = createAction(
  actionScope + "DELETE_PATIENT_JOURNAL_REQUEST"
);
export const deletePatientJournalEntrySuccess = createAction(
  actionScope + "DELETE_PATIENT_JOURNAL_SUCCESS"
);

export const loadPatientHistoryRequest = createAction(actionScope + "LOAD_PATIENT_HISTORY_REQUEST");
export const loadPatientHistorySuccess = createAction(actionScope + "LOAD_PATIENT_HISTORY_SUCCESS");
export const updatePatientHistoryRequest = createAction(
  actionScope + "UPDATE_PATIENT_HISTORY_REQUEST"
);
export const updatePatientHistorySuccess = createAction(
  actionScope + "UPDATE_PATIENT_HISTORY_SUCCESS"
);
export const deletePatientHistoryRequest = createAction(
  actionScope + "DELETE_PATIENT_HISTORY_REQUEST"
);
export const deletePatientHistorySuccess = createAction(
  actionScope + "DELETE_PATIENT_HISTORY_SUCCESS"
);

export const loadPatientTreatmentPlanRequest = createAction(
  actionScope + "LOAD_PATIENT_TREATMENT_PLAN_REQUEST"
);
export const loadPatientTreatmentPlanSuccess = createAction(
  actionScope + "LOAD_PATIENT_TREATMENT_PLANS_SUCCESS"
);
export const updatePatientTreatmentPlanRequest = createAction(
  actionScope + "UPDATE_PATIENT_TREATMENT_PLAN_REQUEST"
);
export const updatePatientTreatmentPlanSuccess = createAction(
  actionScope + "UPDATE_PATIENT_TREATMENT_PLAN_SUCCESS"
);
export const deletePatientTreatmentPlanRequest = createAction(
  actionScope + "DELETE_PATIENT_TREATMENT_PLAN_REQUEST"
);
export const deletePatientTreatmentPlanSuccess = createAction(
  actionScope + "DELETE_PATIENT_TREATMENT_PLAN_SUCCESS"
);

//#endregion

// selectors
export const patientODMSelector = state => state.patientSession.patientODM;
export const patientAssessmentsSelector = state => state.patientSession.patientAssessments;
export const patientMotivationsSelector = state => state.patientSession.patientMotivations;

//#region REFACTOR and DELETE
export const patientSessionSelector = state => state.patientSession;
export const patientNotesSelector = state => state.patientSession.patientNotes;
export const patientQuestionsSelector = state => state.patientSession.patientQuestions;
export const patientHistorySelector = state => state.patientSession.patientHistory;
export const patientJournalSelector = state => state.patientSession.patientJournal;
export const patientChartSelector = state => state.patientSession.patientChart;
export const patientTreatmentPlanSelector = state => state.patientSession.patientTreatmentPlan;
//#endregion

// initial state
const initialState = {
  //these members use the omnDataModel defined by the JSON in this project
  patientODM: null,

  patientMotivations: null,
  motivationODM: null,

  patientAssessments: null,
  assessmentODM: null,

  //#region REFACTOR and DELETE
  patientId: null,
  patientData: null,
  patientNotes: null,
  patientImage: null,
  patientChart: null,
  patientQuestions: null,
  patienceCompliance: null,
  patientHistory: null,
  patientJournal: null,
  patientTreatmentPlan: null,
  //#endregion
};

// reducers
export default handleActions(
  {
    [patientSessionRequestFailed]: state => state,

    [loadPatientODMRequest]: state => state,
    [loadPatientODMSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [setPatientODMRequest]: state => state,
    [setPatientODMSuccess]: (state, { payload }) => ({
      ...state,
      patientId: payload._id, //TODO depricate
      patientODM: payload,
    }),

    [updatePatientRequest]: state => state,
    [updatePatientSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [deletePatientRequest]: state => state,
    [deletePatientSuccess]: (state, { payload }) => ({
      ...state,
    }),

    //#region Assessments
    [loadPatientAssessmentsRequest]: state => state,
    [loadPatientAssessmentsSuccess]: (state, { payload }) => ({
      ...state,
      patientAssessments: payload,
    }),

    [loadAssessmentODMRequest]: state => state,
    [loadAssessmentODMSuccess]: (state, { payload }) => ({
      ...state,
      assessmentODM: payload,
    }),

    [updateAssessmentRequest]: state => state,
    [updateAssessmentSuccess]: (state, { payload }) => ({
      ...state,
      patientAssessments: payload,
    }),

    //#endregion

    //#region Motivations
    [loadPatientMotivationsRequest]: state => state,
    [loadPatientMotivationsSuccess]: (state, { payload }) => ({
      ...state,
      patientMotivations: payload,
    }),

    [loadMotivationODMRequest]: state => state,
    [loadMotivationODMSuccess]: (state, { payload }) => ({
      ...state,
      motivationODM: payload,
    }),

    [updateMotivationRequest]: state => state,
    [updateMotivationSuccess]: (state, { payload }) => ({
      ...state,
      patientMotivations: payload,
    }),

    [deleteMotivationRequest]: state => state,
    [deleteMotivationSuccess]: (state, { payload }) => ({
      ...state,
      patientPatMotivations: payload,
    }),

    //#endregion

    //#region REFACTOR and DELETE

    [loadPatientChartRequest]: state => state,
    [loadPatientChartSuccess]: (state, { payload }) => ({
      ...state,
      patientChart: payload,
    }),

    [loadPatientImageRequest]: state => state,
    [loadPatientImageSuccess]: (state, { payload }) => ({
      ...state,
      patientImage: payload,
    }),

    [loadPatientComplianceRequest]: state => state,
    [loadPatientComplianceSuccess]: (state, { payload }) => ({
      ...state,
      patientCompliance: payload,
    }),

    [loadPatientNotesRequest]: state => state,
    [loadPatientNotesSuccess]: (state, { payload }) => ({
      ...state,
      patientNotes: payload,
    }),
    [updatePatientNoteRequest]: state => state,
    [updatePatientNoteSuccess]: (state, { payload }) => ({
      ...state,
      patientNotes: payload,
    }),
    [deletePatientNoteRequest]: state => state,
    [deletePatientNoteSuccess]: (state, { payload }) => ({
      ...state,
      patientNotes: payload,
    }),
    [loadPatientMotivationsRequest]: state => state,
    [loadPatientMotivationsSuccess]: (state, { payload }) => ({
      ...state,
      patientMotivations: payload,
    }),
    [updateMotivationRequest]: state => state,
    [updateMotivationSuccess]: (state, { payload }) => ({
      ...state,
      patientMotivations: payload,
    }),
    [deleteMotivationRequest]: state => state,
    [deleteMotivationSuccess]: (state, { payload }) => ({
      ...state,
      patientMotivations: payload,
    }),

    [loadPatientQuestionsRequest]: state => state,
    [loadPatientQuestionsSuccess]: (state, { payload }) => ({
      ...state,
      patientQuestions: payload,
    }),
    [updatePatientQuestionRequest]: state => state,
    [updatePatientQuestionSuccess]: (state, { payload }) => ({
      ...state,
      patientQuestions: payload,
    }),
    [deletePatientQuestionRequest]: state => state,
    [deletePatientQuestionSuccess]: (state, { payload }) => ({
      ...state,
      patientQuestions: payload,
    }),

    [updatePatientMedicationsRequest]: state => state,
    [updatePatientMedicationsSuccess]: (state, { payload }) => ({
      ...state,
      patientChart: payload,
    }),

    [loadPatientJournalRequest]: state => state,
    [loadPatientJournalSuccess]: (state, { payload }) => ({
      ...state,
      patientJournal: payload,
    }),
    [updatePatientJournalEntryRequest]: state => state,
    [updatePatientJournalEntrySuccess]: (state, { payload }) => ({
      ...state,
      patientJournal: payload,
    }),
    [deletePatientJournalEntryRequest]: state => state,
    [deletePatientJournalEntrySuccess]: (state, { payload }) => ({
      ...state,
      patientJournal: payload,
    }),

    [updatePatientConditionsRequest]: state => state,
    [updatePatientConditionsSuccess]: (state, { payload }) => ({
      ...state,
      patientChart: payload,
    }),

    [updatePatientSymptomsRequest]: state => state,
    [updatePatientSymptomsSuccess]: (state, { payload }) => ({
      ...state,
      patientChart: payload,
    }),

    [updatePatientGoalsRequest]: state => state,
    [updatePatientGoalsSuccess]: (state, { payload }) => ({
      ...state,
      patientChart: payload,
    }),

    [loadPatientHistoryRequest]: state => state,
    [loadPatientHistorySuccess]: (state, { payload }) => ({
      ...state,
      patientHistory: payload,
    }),
    [updatePatientHistoryRequest]: state => state,
    [updatePatientHistorySuccess]: (state, { payload }) => ({
      ...state,
      patientHistory: payload,
    }),
    [deletePatientHistoryRequest]: state => state,
    [deletePatientHistorySuccess]: (state, { payload }) => ({
      ...state,
      patientHistory: payload,
    }),

    [loadPatientTreatmentPlanRequest]: state => state,
    [loadPatientTreatmentPlanSuccess]: (state, { payload }) => ({
      ...state,
      patientTreatmentPlan: payload,
    }),
    [updatePatientTreatmentPlanRequest]: state => state,
    [updatePatientTreatmentPlanSuccess]: (state, { payload }) => ({
      ...state,
      patientTreatmentPlan: payload,
    }),
    [deletePatientTreatmentPlanRequest]: state => state,
    [deletePatientTreatmentPlanSuccess]: (state, { payload }) => ({
      ...state,
      patientTreatmentPlan: payload,
    }),
    //#endregion
  },
  initialState
);
